import React from "react";
import { useNavigate } from "react-router-dom";

import Footer from "../Home/Footer";

import AuthIcons from "../../hooks/AuthIcons";
import useScrollToTop from "../../hooks/useScrollToTop";

import { useUser } from "../../contexts/UserContext";

import ScoreHero from "./components/ScoreHero";
import ScorePresentation from "./components/ScorePresentation";

import {
  getScoreboardSessionId,
} from "./utils/scoreSession";

export default function MonAppliScorePage() {
  useScrollToTop();

  const navigate = useNavigate();
  const { user } = useUser();

  const openScoreboard = () => {
    const sessionId =
      getScoreboardSessionId(user);

    navigate(
      `/monappliscore/tableau/${sessionId}`
    );
  };

  const scrollToPresentation = () => {
    document
      .getElementById(
        "presentation-monappliscore"
      )
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-white">
      {!user ? <AuthIcons /> : null}

      <main>
        <ScoreHero
          onOpenScoreboard={
            openScoreboard
          }
          onDiscover={
            scrollToPresentation
          }
        />

        <ScorePresentation
          onOpenScoreboard={
            openScoreboard
          }
        />
      </main>

      <Footer />
    </div>
  );
}